import { EmployeeServicePath, STAFF_REQUEST } from "utils/constants";
import { List, SelectInput } from "react-admin";

import { StaffRequestType } from "utils/choices";
import StaffRequestsTableBody from "../components/StaffRequestsTableBody";

const ListStaffRequests = ({ title }) => {
  const filters = [
    <SelectInput
      source="type"
      label="Тип"
      choices={StaffRequestType}
      emptyText="Всички заявки"
      SelectProps={{ displayEmpty: true }}
      InputLabelProps={{ shrink: true }}
      style={{ width: 240 }}
      alwaysOn
    />,
  ];

  return (
    <List
      exporter={false}
      title={title}
      resource={`${EmployeeServicePath}${STAFF_REQUEST}`}
      filters={filters}
    >
      <StaffRequestsTableBody />
    </List>
  );
};

export default ListStaffRequests;
